export default __webpack_public_path__ + "static/media/3VA_UL.8c6fad8b.jpg";